module.exports = __webpack_public_path__ + "media/images/icons/rooms/sauna-1c171064f479e5ba807604852741ffa5.svg";